import { render, staticRenderFns } from "./IsiEkspektasiPerilaku.vue?vue&type=template&id=5cf0b9a6&scoped=true&lang=html&"
import script from "./IsiEkspektasiPerilaku.vue?vue&type=script&lang=js&"
export * from "./IsiEkspektasiPerilaku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0b9a6",
  null
  
)

export default component.exports